/**
 * Mock data for Delivered Trips in Transit Dashboard
 * Matches the ACTUAL API response structure from /linehaul/api/v1/transit-dashboard/delivered-trips
 */

// Backend API response format (matches real API)
const defaultDeliveredTripsApiFormat = [
  {
    tripNumber: 756394,
    loadBoardScheduleId: 100,
    originSic: {
      id: 101,
      code: "CHI",
      lhRegionId: 1,
      ownership: "C",
      timeZone: "America/Chicago",
    },
    destinationSic: {
      id: 102,
      code: "LAX",
      lhRegionId: 2,
      ownership: "C",
      timeZone: "America/Los_Angeles",
    },
    stops: ["DEN"],
    deadheadOrigin: "CHI",
    deadheadDestination: "",
    bookingNumber: "BK123456",
    carrier: {
      id: 1,
      isActive: true,
      name: "Swift Transportation",
      code: "SWFT",
    },
    trailer: "TRL789",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-10T08:30:00"),
    eta: new Date("2026-02-11T14:30:00"),
    ata: new Date("2026-02-11T14:25:00"),
    tripStatus: "CLOS",
    isStarred: true,
    isNote: true,
    employeeDrivers: [{ name: "John Smith" }, { name: "Jane Doe" }],
    ibCuttime: new Date("2026-02-10T10:00:00"),
    category: "OnTime",
    effectiveFromUtc: "2026-02-10T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-11T14:25:00"),
  },
  {
    tripNumber: 756395,
    loadBoardScheduleId: 102,
    originSic: {
      id: 103,
      code: "ATL",
      lhRegionId: 3,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 104,
      code: "DFW",
      lhRegionId: 4,
      ownership: "C",
      timeZone: "America/Chicago",
    },
    stops: ["MEM"],
    deadheadOrigin: "",
    deadheadDestination: "DFW",
    bookingNumber: "BK123457",
    carrier: {
      id: 2,
      isActive: true,
      name: "Knight Transportation",
      code: "KNHT",
    },
    trailer: "TRL790",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-09T06:00:00"),
    eta: new Date("2026-02-10T16:45:00"),
    ata: new Date("2026-02-10T16:40:00"),
    tripStatus: "ARIV",
    isStarred: false,
    isNote: false,
    employeeDrivers: [{ name: "Mike Johnson" }],
    ibCuttime: new Date("2026-02-09T07:00:00"),
    category: "Late",
    effectiveFromUtc: "2026-02-09T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-10T16:40:00"),
  },
  {
    tripNumber: 756396,
    loadBoardScheduleId: 103,
    originSic: {
      id: 105,
      code: "NYC",
      lhRegionId: 5,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 106,
      code: "MIA",
      lhRegionId: 6,
      ownership: "C",
      timeZone: "America/New_York",
    },
    stops: ["PHL"],
    deadheadOrigin: "NYC",
    deadheadDestination: "MIA",
    bookingNumber: "BK123458",
    carrier: {
      id: 3,
      isActive: true,
      name: "Schneider National",
      code: "SCHN",
    },
    trailer: "TRL791",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-11T10:15:00"),
    eta: new Date("2026-02-11T20:30:00"),
    ata: new Date("2026-02-11T20:15:00"),
    tripStatus: "ENRT",
    isStarred: true,
    isNote: true,
    employeeDrivers: [{ name: "Robert Williams" }, { name: "Sarah Brown" }],
    ibCuttime: new Date("2026-02-11T11:30:00"),
    category: "OnTime",
    effectiveFromUtc: "2026-02-11T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-11T20:15:00"),
  },
  {
    tripNumber: 756397,
    loadBoardScheduleId: 104,
    originSic: {
      id: 107,
      code: "SEA",
      lhRegionId: 7,
      ownership: "C",
      timeZone: "America/Los_Angeles",
    },
    destinationSic: {
      id: 108,
      code: "PHX",
      lhRegionId: 8,
      ownership: "C",
      timeZone: "America/Phoenix",
    },
    stops: ["CHT"],
    deadheadOrigin: "",
    deadheadDestination: "",
    bookingNumber: "BK123459",
    carrier: {
      id: 4,
      isActive: true,
      name: "Werner Enterprises",
      code: "WERN",
    },
    trailer: "TRL792",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-08T07:00:00"),
    eta: new Date("2026-02-09T12:00:00"),
    ata: new Date("2026-02-09T11:55:00"),
    tripStatus: "CLOS",
    isStarred: false,
    isNote: false,
    employeeDrivers: [{ name: "David Lee" }],
    ibCuttime: new Date("2026-02-08T08:00:00"),
    category: "AtRisk",
    effectiveFromUtc: "2026-02-08T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-09T11:55:00"),
  },
  {
    tripNumber: 756398,
    loadBoardScheduleId: 105,
    originSic: {
      id: 109,
      code: "BOS",
      lhRegionId: 9,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 110,
      code: "CHI",
      lhRegionId: 1,
      ownership: "C",
      timeZone: "America/Chicago",
    },
    stops: ["ALB"],
    deadheadOrigin: "BOS",
    deadheadDestination: "",
    bookingNumber: "BK123460",
    carrier: {
      id: 5,
      isActive: true,
      name: "J.B. Hunt",
      code: "JBHT",
    },
    trailer: "TRL793",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-07T09:00:00"),
    eta: new Date("2026-02-08T15:00:00"),
    ata: new Date("2026-02-08T14:50:00"),
    tripStatus: "ARIV",
    isStarred: false,
    isNote: true,
    employeeDrivers: [{ name: "Chris Anderson" }],
    ibCuttime: new Date("2026-02-07T10:00:00"),
    category: "OnTime",
    effectiveFromUtc: "2026-02-07T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-08T14:50:00"),
  },
  {
    tripNumber: 756399,
    loadBoardScheduleId: 106,
    originSic: {
      id: 111,
      code: "DET",
      lhRegionId: 10,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 112,
      code: "IND",
      lhRegionId: 11,
      ownership: "C",
      timeZone: "America/New_York",
    },
    stops: ["TOL"],
    deadheadOrigin: "",
    deadheadDestination: "",
    bookingNumber: "BK123461",
    carrier: {
      id: 6,
      isActive: true,
      name: "Covenant Transport",
      code: "CVNT",
    },
    trailer: "TRL794",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-06T11:00:00"),
    eta: new Date("2026-02-07T13:00:00"),
    ata: new Date("2026-02-07T12:55:00"),
    tripStatus: "ENRT",
    isStarred: true,
    isNote: false,
    employeeDrivers: [{ name: "Michael Taylor" }],
    ibCuttime: new Date("2026-02-06T12:00:00"),
    category: "Late",
    effectiveFromUtc: "2026-02-06T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-07T12:55:00"),
  },
  {
    tripNumber: 756400,
    loadBoardScheduleId: 107,
    originSic: {
      id: 113,
      code: "POR",
      lhRegionId: 12,
      ownership: "C",
      timeZone: "America/Los_Angeles",
    },
    destinationSic: {
      id: 114,
      code: "SLC",
      lhRegionId: 13,
      ownership: "C",
      timeZone: "America/Denver",
    },
    stops: ["BOI"],
    deadheadOrigin: "POR",
    deadheadDestination: "SLC",
    bookingNumber: "BK123462",
    carrier: {
      id: 7,
      isActive: true,
      name: "Prime Inc",
      code: "PRIM",
    },
    trailer: "TRL795",
    shipmentTags: ["CC", "UC"],
    pickupDate: new Date("2026-02-05T05:30:00"),
    eta: new Date("2026-02-06T18:00:00"),
    ata: new Date("2026-02-06T17:50:00"),
    tripStatus: "CLOS",
    isStarred: false,
    isNote: true,
    employeeDrivers: [{ name: "Jennifer Martinez" }, { name: "Thomas Wilson" }],
    ibCuttime: new Date("2026-02-05T07:00:00"),
    category: "OnTime",
    effectiveFromUtc: "2026-02-05T00:00:00Z",
    loadingDay: 0,
    latestModifiedOn: new Date("2026-02-06T17:50:00"),
  },
];

export const mockDeliveredTrips = {
  default: defaultDeliveredTripsApiFormat,
  totalCount: defaultDeliveredTripsApiFormat.length,
} as const;
